import { createContext, useContext, useState, ReactNode } from 'react';

type ManagerContextType = {
  managerId: number | null;
  setManagerId: (id: number | null) => void;
};

const ManagerContext = createContext<ManagerContextType | undefined>(undefined);

export const ManagerProvider = ({ children }: { children: ReactNode }) => {
  const [managerId, setManagerId] = useState<number | null>(null);

  return (
    <ManagerContext.Provider value={{ managerId, setManagerId }}>
      {children}
    </ManagerContext.Provider>
  );
};

export const useManager = () => {
  const context = useContext(ManagerContext);

  if (!context) {
    throw new Error('useManager must be used inside ManagerProvider');
  }

  return context;
};